<template>
  <div class="topup-back">
    <div v-if="isLoading" class="text">
      <p>Zaczekaj. Trwa weryfikacja zgłoszenia...</p>
    </div>
    <div v-if="!isLoading">
      <div>
        <div class="text" v-if="isStatusUnsubscribe">
          <h1>Dziękujemy za zgłoszenie.</h1>
          <p>
            Twój kontakt został usunięty.<br>Nie będziesz otrzymywać tego typu wiadomości.<br>
            Pozdrawiamy!
          </p>
        </div>
        <div class="text" v-if="!isStatusUnsubscribe">
          <h1>Ups... Coś poszło nie tak.</h1>
          <p>Spróbuj jeszcze raz usunąć subskrypcję.</p>
        </div>
        <div class="button">
          <button type="button" class="btn" @click="goToTopup">Doładuj telefon</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import UnsubscribeMixin from '@/common/mixins/views/Unsubscribe.mixin'

export default {
  name: 'Unregister',
  mixins: [UnsubscribeMixin]
}
</script>

<style src="../assets/scss/back.scss" lang="scss" scoped></style>
